export default __webpack_public_path__ + "static/media/2_Georgia.5b3347a0.mp3";